enum FuelType {
  Diesel = 'diesel',
  Petrol = 'petrol',
  Hybrid = 'pluginHybrid',
  Electric = 'el',
  MildHybrid = 'mildHybrid',
}

export default FuelType;
